export default __webpack_public_path__ + "static/media/meeting_detail_icon.6ec3da64.svg";